import kebabCase from 'lodash/kebabCase'

import GuidingText from 'common/components/guidingText'

import { InputElement } from '../../interface'
import NumberInput from '../NumberInput'
import {
  MAX_FLOAT_VALUE,
  MIN_FLOAT_VALUE,
} from '../UiBuilder/UiBuilder.component'

import FormItem from './FormItem'
import { FormInstance } from './interfaces'

type Props = {
  field: InputElement
  form: FormInstance
  onChange: (value: string) => void
  className?: string
  disabled?: boolean
}

const Rate: React.FC<Props> = ({
  field,
  form,
  className,
  disabled,
  onChange,
}) => {
  const { getFieldDecorator } = form

  return (
    <FormItem
      field={field}
      form={form}
      className={`updated-component${className ? ` ${className}` : ''}`}
    >
      <div>
        {getFieldDecorator(field.property_name, {
          rules: field.rules,
        })(
          <NumberInput
            disabled={disabled}
            data-cy={`campaign-setup-${kebabCase(field.field_id)}`}
            data-testid={`campaign-setup-${kebabCase(field.field_id)}`}
            id={field.field_id}
            style={{ width: 135 }}
            size="large"
            placeholder={field.placeholder}
            min={field.min || MIN_FLOAT_VALUE}
            max={field.max || MAX_FLOAT_VALUE}
            step={field.step || 1}
            onChange={(value) => {
              if (
                value !== null &&
                value >= MIN_FLOAT_VALUE &&
                value <= MAX_FLOAT_VALUE
              ) {
                onChange(value?.toString() ?? '')
              }
            }}
          />
        )}
        {field.tooltip && <GuidingText text={field.tooltip} />}
      </div>
    </FormItem>
  )
}

export default Rate
